<template>
  <Drawer v-model:open="isOpen" :direction="isDesktop ? 'right' : 'bottom'">
    <DrawerTrigger v-show="props.triggerButtonName" as-child>
      <div class="mx-auto w-[calc(100%-16px)] max-w-[330px] justify-end">
        <AtomsPrimaryButton :on-click="props.onClick">{{ props.triggerButtonName }}</AtomsPrimaryButton>
      </div>
    </DrawerTrigger>
    <DrawerContent class="z-[999] bg-white font-Spectral md:h-screen" :position="isDesktop ? 'right' : 'bottom'">
      <!-- shadcnのお作法的に定義しないとwarningが出るので空定義 -->
      <DrawerTitle></DrawerTitle>
      <img alt="close modal" class="absolute right-0 top-5 z-[3] h-10 w-10 cursor-pointer p-2 md:top-1" src="@/assets/icon/close/black.svg" @click="closeDrawer" />
      <DrawerDescription class="max-h-[100dvh] overflow-y-auto pt-4 md:pt-0"> <slot /></DrawerDescription>
    </DrawerContent>
  </Drawer>
</template>

<script lang="ts" setup>
import { useMediaQuery } from '@vueuse/core';

import { Drawer, DrawerContent, DrawerDescription, DrawerTitle, DrawerTrigger } from '@/components/lib/shadcn-vue/drawer';
interface Props {
  onClick: () => void;
  triggerButtonName?: string; // 外部でボタンを配置したい場合は指定しない
  externalOpenState?: boolean; // 外部から開閉状態を制御したい場合に指定
}
const props = defineProps<Props>();
const emit = defineEmits(['update:isModalOpen']);
const isDesktop = useMediaQuery('(min-width: 768px)');
const isOpen = ref(false);
const closeDrawer = () => {
  isOpen.value = false;
};
watch(
  () => props.externalOpenState,
  (newValue) => {
    if (typeof newValue === 'boolean') {
      isOpen.value = newValue;
    }
  },
);
watch(
  () => isOpen.value,
  (newValue) => {
    emit('update:isModalOpen', newValue); // isOpenの変更を親要素に反映
  },
);
</script>
